<template>
  <b-card
    class="h-100 mb-0"
    body-class="p-1"
  >
    <template v-if="!loading">
      <small class="text-muted">
        {{ header }}
        <GjIcon
          v-b-tooltip.hover.bottom="info"
          size="16px"
          name="Info"
        />
      </small>
      <div
        v-if="compareMode"
        class="d-flex"
      >
        <span :class="textClass">{{ percentage }}%</span>
      </div>
      <h4 v-if="isPercentage">
        {{ mainValue | formatNumber }}{{ symbol }}
      </h4>
      <h4 v-else>
        {{ mainValue | formatInteger }}{{ symbol }}
      </h4>
      <small
        v-if="!hideFooter"
        class="text-muted d-block"
      >
        <template v-if="isFooterPercentage"> {{ footerText }}: {{ mainFooter | formatNumber }}{{ footerSymbol }} </template>
        <template v-else> {{ footerText }}: {{ mainFooter | formatInteger }}{{ footerSymbol }} </template>
      </small>
      <small v-if="compareMode"> <i class="dot" /> {{ $tk('ClientPortal.Property.Earnings.FirstPeriod') }} </small>
      <template v-if="compareMode">
        <h4 v-if="isPercentage">
          {{ compareValue | formatNumber }}{{ symbol }}
        </h4>
        <h4 v-else>
          {{ compareValue | formatInteger }}{{ symbol }}
        </h4>
        <small
          v-if="!hideFooter"
          class="text-muted d-block"
        >
          <template v-if="isFooterPercentage"> {{ footerText }}: {{ compareFooter | formatNumber }}{{ footerSymbol }} </template>
          <template v-else> {{ footerText }}: {{ compareFooter | formatInteger }}{{ footerSymbol }} </template>
        </small>
        <small v-if="compareMode"> <i class="dot bg-warning" /> {{ $tk('ClientPortal.Property.Earnings.SecondPeriod') }} </small>
      </template>
    </template>
    <template v-else>
      <b-skeleton
        width="30%"
        class="mt-50"
      />
      <b-skeleton
        class="mt-n50"
        width="50%"
        height="20%"
      />
      <b-skeleton
        width="40%"
      />
      <template v-if="compareMode">
        <b-skeleton
          width="30%"
          class="mt-50"
        />
        <b-skeleton
          class="mt-n50"
          width="50%"
          height="20%"
        />
        <b-skeleton
          width="40%"
          class="mb-3"
        />
      </template>
    </template>
  </b-card>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    header: String,
    info: String,
    footerText: String,
    mainValue: {
      type: Number,
      default: 0,
    },
    mainFooter: {
      type: Number,
      default: 0,
    },
    compareValue: {
      type: Number,
      default: 0,
    },
    compareFooter: {
      type: Number,
      default: 0,
    },
    compareMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    symbol: {
      type: String,
      default: '',
    },
    footerSymbol: {
      type: String,
      default: '',
    },
    isPercentage: {
      type: Boolean,
      default: false,
    },
    isFooterPercentage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textClass() {
      const diff = this.mainValue - this.compareValue
      if (diff < 0) return 'text-danger'
      if (diff > 0) return 'text-success'
      return ''
    },
    percentage() {
      if (this.compareValue === 0) return 0
      return (((this.mainValue - this.compareValue) / this.compareValue) * 100).toFixed(2)
    },
  },
}
</script>
